import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "print:hidden"
}
const _hoisted_2 = ["href"]

import { computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useMeStore } from '@/services/UserService/useMeStore';
import { getSupportArticleUrl } from '@/services/supportUrlService';

const NOTICE_KEY = 'mattersPageUpgrade.v1';


export default /*@__PURE__*/_defineComponent({
  __name: 'MattersUpgradeNotice',
  setup(__props) {

const SUPPORT_URL = getSupportArticleUrl('mattersPageUpgrade');

// Remembered on the account rather than in localStorage, so dismissing it on one
// machine dismisses it everywhere. Versioned so a later announcement starts fresh
// rather than inheriting this dismissal.
const meStore = useMeStore();
const { me, settings } = storeToRefs(meStore);

const matterTerm = computed(() => me.value?.terms?.Matter || 'Matter');

// Hidden immediately on close, before the PUT lands - and left hidden if it fails, so
// the worst a failed save can do is bring the notice back on the next visit.
const closed = ref(false);
const dismissedNotices = computed(() => settings.value?.dismissedNotices ?? []);
const visible = computed(
  () => !closed.value && !dismissedNotices.value.includes(NOTICE_KEY),
);

// ll-standards-ignore LL040 -- updateMe() catches its own errors and never rethrows
// (useMeStore.ts), so a try/catch here would be a branch that cannot run. The rule guards
// against an unhandled rejection stranding a spinner; there is no spinner and no rejection.
async function dismiss(): Promise<void> {
  closed.value = true;
  // The endpoint takes the whole array, not an append, so send the keys already dismissed
  // alongside the new one.
  await meStore.updateMe({
    settings: { dismissedNotices: [...dismissedNotices.value, NOTICE_KEY] },
  });
}

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!

  return (visible.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_alert, {
          type: "info",
          variant: "tonal",
          density: "compact",
          closable: "",
          class: "mb-4 mt-4 text-sm",
          "data-cy": "matters-upgrade-notice",
          "onClick:close": dismiss
        }, {
          text: _withCtx(() => [
            _createTextVNode(" The " + _toDisplayString(matterTerm.value) + "s page has been rebuilt to support bulk editing. ", 1),
            _createElementVNode("a", {
              href: _unref(SUPPORT_URL),
              target: "_blank",
              rel: "noopener noreferrer",
              class: "underline",
              "data-cy": "matters-upgrade-link"
            }, "See what changed", 8, _hoisted_2)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})